import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  targetId: null,
  values: {},
  
  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'answeredAt':
          if (!value) return Constants.BlankValue
          return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
        case 'answer':
          if (!value) return Constants.BlankValue
          return JSON.parse(value).answerMessage ||
            JSON.parse(value).labelText
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
	show ({commit}, targetId) {
    commit('setTargetId', targetId)
    commit('setUpdated', false)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * 初期データを読出し
   */
  loadModel ({commit}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['log'],
        ['v1LogResponseGet'],
        [{
          functionAnswerUuid: state.targetId
        }])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('inited', res[0].data)
            console.log('values', state.values)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  inited (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpStatus', data.responseStatus)
    Vue.set(state.values, 'inpNote', data.responseNote)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // updated
  setUpdated (state, flag) {
    state.updated = flag
  },

  // reset
  reset (state) {
    state.targetId = null
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
